<template>
    <svg viewBox="0 0 426.365 426.365">
        <path style="fill:#01CB3E;" d="M347.683,0h-85.956l-35.418,68.554c-4.278,8.281-12.82,13.483-22.141,13.483H78.683v108.882h67.924  c7.52,0,12.37,7.964,8.918,14.645L78.683,354.299v72.066h85.81l35.418-68.554c4.278-8.281,12.82-13.483,22.141-13.483h125.631  V235.446h-68.07c-7.52,0-12.37-7.964-8.918-14.645l76.988-149.016L347.683,0L347.683,0z" />
    </svg>
</template>

<script>
export default {
    name: 'Deviantart'
}
</script>
